import HeroSection from "../../components/marketing/HeroSection";
import ShowcaseSection from "../../components/marketing/ShowcaseSection";

const AssistByScanHomePage = () => {
  return (
    <div className="assist">
      <HeroSection />
      <ShowcaseSection />
    </div>
  );
};

export default AssistByScanHomePage;